/**
 * Parse Store Hours
 * @param {Array} Stockist store custom fields
 * @returns {String} hours display
 */
function parseStoreHours(customDateTimes) {
  const weekdays = [
    {
      day: 'Sun',
      hours: '',
    },
    {
      day: 'Mon',
      hours: '',
    },
    {
      day: 'Tue',
      hours: '',
    },
    {
      day: 'Wed',
      hours: '',
    },
    {
      day: 'Thu',
      hours: '',
    },
    {
      day: 'Fri',
      hours: '',
    },
    {
      day: 'Sat',
      hours: '',
    },
  ];

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const dateTime = new Date();
  const month = months[dateTime.getMonth()];
  const day = dateTime.getDate();
  const year = dateTime.getFullYear();
  const currentDay = dateTime.getDay();

  let text = '';

  customDateTimes.forEach((customDateTime) => {
    const customDay = customDateTime.name.replace('Store Hours: ', '');
    const d = weekdays.find((weekday) => weekday.day === customDay);
    d.hours = customDateTime.value;
  });

  const weekdayNow = weekdays[dateTime.getDay()];
  const storeDateTimes = weekdayNow;
  const nextDayStoreDateTimes = findOpenHours(weekdays, currentDay);

  if (!storeDateTimes.day && !nextDayStoreDateTimes.day) return text;

  let storeOpenHours;
  let storeOpenDateTime;
  let storeCloseHours;
  let storeCloseDateTime;
  let nextStoreOpenHours;
  let nextStoreOpenDateTime;

  // Set store hours
  if (storeDateTimes.hours) {
    const storeHours = storeDateTimes.hours.split('-');
    storeOpenDateTime = new Date(`${month}, ${day} ${year} ${storeHours[0]}`);
    storeOpenHours = setAMPM(storeOpenDateTime);
    storeCloseDateTime = new Date(`${month}, ${day} ${year} ${storeHours[1]}`);
    storeCloseHours = setAMPM(storeCloseDateTime);
  }

  // Set next day store hours
  if (nextDayStoreDateTimes.hours) {
    const nextDayStoreHours = nextDayStoreDateTimes.hours.split('-');
    nextStoreOpenDateTime = new Date(`${month}, ${day} ${year} ${nextDayStoreHours[0]}`);
    nextStoreOpenHours = setAMPM(nextStoreOpenDateTime);
  }

  // Check if current time is before store open hours
  if (!storeDateTimes.hours && nextDayStoreDateTimes.hours) {
    text = `Closed<br>Opens at ${nextStoreOpenHours} on ${nextDayStoreDateTimes.day}`;
  }

  // Check if current time is before store open hours
  if (dateTime < storeOpenDateTime) {
    text = `Opens at ${storeOpenHours}`;
  }

  // Check if current time is within store open hours
  if (dateTime >= storeOpenDateTime && dateTime <= storeCloseDateTime) {
    text = `Open until ${storeCloseHours}`;
  }

  // Check if current time is past store close hours
  if (dateTime >= storeCloseDateTime) {
    text = `Closed<br>Opens at ${nextStoreOpenHours} on ${nextDayStoreDateTimes.day}`;
  }

  return text;
}

/**
 * Find open store hours
 * @param {Array} weekdays array with hours and days
 * @param {Number} current weekday number (0-6)
 * @return {Object} object with day and hours
 */
function findOpenHours(weekdays, currentDay) {
  let hours;
  let nextDay = currentDay + 1;
  const weekdaysLength = weekdays.length - 1;

  // Check for if the current day is Saturday
  // Start at beginning of week
  if (currentDay === weekdaysLength) {
    weekdays.forEach((weekday) => {
      if (weekday.hours) {
        hours = {
          day: weekday.day,
          hours: weekday.hours,
        };
      }
      return hours;
    });
  }

  // While the next day is within the weekdays array length and no hours are found
  // Search for next day
  while (nextDay <= weekdaysLength && !hours?.length) {
    const nextDayHours = weekdays[nextDay].hours;
    const nextDayWeekday = weekdays[nextDay].day;

    // If next day has hours, set hours and stop loop
    if (nextDayHours) {
      hours = {
        day: nextDayWeekday,
        hours: nextDayHours,
      };

      break;
    }

    // If next day is the last day of the week,
    // start at the beginning of the week
    if (nextDay === weekdaysLength) {
      nextDay = 0;

      if (weekdays[nextDay].hours) {
        hours = {
          day: weekdays[nextDay].day,
          hours: weekdays[nextDay].hours,
        };

        break;
      }
    }

    nextDay += 1;
  }

  return hours;
}

/**
 * Set AM/PM
 * @param {Number} time current 2-digit time
 * @return {String} am/pm
 */
function setAMPM(time) {
  const currentTime = time.getHours();

  if (currentTime === 12) return `${currentTime}pm`;
  if (currentTime > 12) return `${currentTime - 12}pm`;
  return `${currentTime}am`; // if (currentTime < 12)
}

export default parseStoreHours;
